module.exports = __webpack_public_path__ + "media/application/images/demo/content_2-612858491ab108f9440b8fe0a4ec5be5.jpg";